import React from "react";
import logo from "../assets/logoWhite.png";
import BtnRounded from "../components/sub-comps/BtnRounded";
import OpenCalendly from "../components/sub-comps/OpenCalendly";
import ContactInfo from "./FooterContactInfo";
function Footer() {
  return (
    <footer className="bg-customDark text-gray-300">
      <div className="container mx-auto px-6 md:px-8 lg:px-8 py-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Logo and Social Links */}
            <div className="space-y-4 ">
              <div>
                <a href="/">
                  <div className="flex items-center space-x-2 text-2xl font-medium ">
                    <img src={logo} alt="AI Logo" className="w-40" />
                  </div>
                </a>
              </div>
              <p className="max-w-md pr-16 text-sm text-gray-400">
                Gardez Votre Sourire Propre Et Brillant.
              </p>
              {/* <div className="flex space-x-4">
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gray-300 transition-colors"
                  aria-label="LinkedIn"
                >
                  <svg
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    className="h-6 w-6"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gray-300 transition-colors"
                  aria-label="Twitter"
                >
                  <svg
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    className="h-6 w-6"
                  >
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
                  </svg>
                </a>
              </div> */}
            </div>

            {/* Clinic Info and Booking Button */}
            <div className="space-y-4 ">
              <h2 className="text-xl font-semibold text-white">
                À Propos Du Centre
              </h2>
              <p className="text-gray-400 text-sm">
                Au Centre Dentaire Cherkaoui, votre sourire est notre priorité !
                Notre équipe dévouée de professionnels dentaires allie
                technologie de pointe et approche personnalisée pour offrir des
                soins exceptionnels dans un cadre chaleureux et accueillant. Des
                consultations de routine aux traitements avancés, nous sommes
                engagés à améliorer votre santé bucco-dentaire et votre
                confiance. Faites-nous confiance pour vous aider à obtenir le
                sourire éclatant que vous méritez !
              </p>
              <BtnRounded bgColor="bg-customAqua100">
                <OpenCalendly />
              </BtnRounded>
            </div>

            {/* Additional Column for Customization */}
            <div className="space-y-4 flex flex-col items-start pl-0 lg:pl-10">
              <h2 className="text-xl font-semibold text-white">Contact Nous</h2>

              {/* Phone Info */}
              <div className="flex items-start space-x-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  className="w-6 h-6 text-customAqua100"
                >
                  <path d="M6.62 10.79a15.08 15.08 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.23 11.37 11.37 0 004.52 1.11 1 1 0 011 1v3.8a1 1 0 01-1 1A19.06 19.06 0 013 5a1 1 0 011-1h3.8a1 1 0 011 1 11.37 11.37 0 001.11 4.52 1 1 0 01-.23 1.11z" />
                </svg>
                <div>
                  <p className="font-medium text-gray-300">Téléphone</p>
                  <p className="text-gray-400">0530356020</p>
                  <p className="text-gray-400">0663391500</p>
                </div>
              </div>

              {/* Address Info */}
              <div className="flex items-start space-x-4">
                
              </div>
              <ContactInfo/>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8">
            <p className="text-center text-sm text-gray-500">
              © 2024 Centre Dentaire Cherkaoui. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
